// extracted by mini-css-extract-plugin
module.exports = {"table":"CurrentMonthlyPremiumCard_table__RA8xy"};